/* unplugin-vue-components disabled */import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/filter.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a1a81d04"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "device-alarm-top"
};
var _hoisted_2 = {
  class: "footer-left"
};
var _hoisted_3 = {
  key: 0,
  class: "van-collapse-item-status-ing van-collapse-item-status"
};
var _hoisted_4 = {
  key: 1,
  class: "van-collapse-item-status-uncomplete van-collapse-item-status"
};
var _hoisted_5 = {
  class: "footer-right"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-top-title"
  }, "更多筛选", -1);
});
var _hoisted_8 = {
  class: "filter-content"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-content-label"
  }, "设备型号", -1);
});
var _hoisted_10 = {
  class: "filter-content"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "filter-content-label"
  }, "告警状态", -1);
});
var _hoisted_12 = {
  class: "popup-btn filter-action-btn"
};
var _hoisted_13 = {
  class: "fixed-button"
};
import CollapseList from './CollapseList.vue';
import ContentPage from '@/components/ContentPage/index.vue';
import { useStore } from '@/store';
import { showToast } from 'vant';
import { postWarnRuleList } from '@/service/deviceAlarm/index';
import './index.less';
import './common.less';
var __default__ = {
  name: 'DeviceAlarm'
};
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  setup: function setup(__props) {
    var router = useRouter();
    var store = useStore();
    var route = useRoute();
    var searchVal = ref('');
    var filterModalShow = ref(false);
    var beforePath = ref('');
    var beforePathObj = ref();
    //告警状态
    var warnStatus = reactive({
      value: null,
      label: '',
      list: [{
        text: '已修复',
        value: '0'
      }, {
        text: '未修复',
        value: '1'
      }],
      warnStatusPicker: false
    });
    var deviceModel = ref('');
    var oldScrollTop = ref(0);
    var loading = ref(true);
    var listloading = ref(false);
    var finished = ref(false);
    var alarmList = ref([]);
    var scrollTop = computed(function () {
      return store.getters['patrolScheme/getScrollTop'];
    });
    var page = ref(1);
    var pageSize = ref(15);
    var totalPage = ref(0);
    var goToAddRule = function goToAddRule() {
      router.push({
        path: '/deviceAlarm/addAlarmRule'
      });
    };
    var onClear = function onClear() {
      finished.value = false;
      page.value = 1;
      postWarnRule();
    };
    var onSearchVal = function onSearchVal(value) {
      finished.value = false;
      page.value = 1;
      postWarnRule({
        deviceModel: deviceModel.value,
        device_warn_status: warnStatus.value,
        deviceName: searchVal.value
      });
    };
    var onRefresh = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              finished.value = false;
              _context.prev = 1;
              page.value = 1;
              _context.next = 5;
              return postWarnRule({
                deviceModel: deviceModel.value,
                device_warn_status: warnStatus.value,
                deviceName: searchVal.value
              });
            case 5:
              showToast('刷新成功');
              loading.value = false;
              _context.next = 13;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              showToast('刷新失败');
              loading.value = false;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 9]]);
      }));
      return function onRefresh() {
        return _ref.apply(this, arguments);
      };
    }();
    var goToDetail = function goToDetail(id) {
      router.push({
        path: '/deviceAlarm/detail',
        query: {
          id: id
        }
      });
    };
    var onFilterSearch = function onFilterSearch() {
      console.log(1, '1');
      filterModalShow.value = true;
    };
    // 处理
    var goToHandle = function goToHandle(id) {
      router.push({
        path: '/deviceAlarm/handleAlarm',
        query: {
          id: id
        }
      });
    };
    var onStatusConfirm = function onStatusConfirm(value) {
      warnStatus.value = value.value;
      warnStatus.label = value.text;
      warnStatus.warnStatusPicker = false;
    };
    var onRest = function onRest() {
      warnStatus.value = null;
      warnStatus.label = '';
      deviceModel.value = '';
    };
    var onFilterOk = function onFilterOk() {
      filterModalShow.value = false;
      finished.value = false;
      page.value = 1;
      postWarnRule({
        deviceModel: deviceModel.value,
        device_warn_status: warnStatus.value,
        deviceName: searchVal.value
      });
    };
    var onFilterCancel = function onFilterCancel() {
      filterModalShow.value = false;
    };
    var onLoad = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              listloading.value = true;
              _context2.next = 4;
              return postWarnRule({
                deviceModel: deviceModel.value,
                device_warn_status: warnStatus.value,
                deviceName: searchVal.value
              });
            case 4:
              listloading.value = false;
              _context2.next = 11;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              listloading.value = false;
              finished.value = true;
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7]]);
      }));
      return function onLoad() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onScrollHandle = function onScrollHandle(event) {
      // 滚动条距文档顶部的距离
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动条滚动的距离
      var scrollStep = scrollTop - oldScrollTop.value;
      // console.log('header 滚动距离 ', scrollTop);
      // 更新——滚动前，滚动条距文档顶部的距离
      oldScrollTop.value = scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //你想做的事情
        // console.log('header  你已经到底部了');
      }
      if (scrollStep < 0) {
        // console.log('header 滚动条向上滚动了！');
      } else {
        // console.log('header  滚动条向下滚动了！');
      }
      // 判断是否到了最顶部
      // if (scrollTop <= 0) {
      //   console.log('header 到了最顶部');
      // }
      store.commit('deviceAlarm/setScrollTop', scrollTop);
    };
    // 告警列表
    var postWarnRule = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data) {
        var alarmRes, alarmData, newList;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              listloading.value = true;
              _context3.next = 4;
              return postWarnRuleList({
                pageIndex: page.value,
                pageSize: pageSize.value,
                t: data
              });
            case 4:
              alarmRes = _context3.sent;
              if (!(alarmRes.status != 1)) {
                _context3.next = 8;
                break;
              }
              finished.value = true;
              return _context3.abrupt("return", Promise.reject());
            case 8:
              alarmData = (alarmRes === null || alarmRes === void 0 ? void 0 : alarmRes.data) || {};
              newList = (alarmData === null || alarmData === void 0 ? void 0 : alarmData.records) || [];
              totalPage.value = alarmData === null || alarmData === void 0 ? void 0 : alarmData.pages;
              if (page.value === 1) {
                alarmList.value = [];
              }
              newList = [].concat(_toConsumableArray(alarmList.value), _toConsumableArray(newList));
              if ((alarmData === null || alarmData === void 0 ? void 0 : alarmData.pages) <= page.value) {
                finished.value = true;
              }
              page.value = page.value + 1;
              alarmList.value = newList;
              listloading.value = false;
              return _context3.abrupt("return", Promise.resolve());
            case 20:
              _context3.prev = 20;
              _context3.t0 = _context3["catch"](0);
              listloading.value = false;
              finished.value = true;
              return _context3.abrupt("return", Promise.reject());
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 20]]);
      }));
      return function postWarnRule(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    router.beforeEach(function (to, from) {
      beforePath.value = from.fullPath;
      beforePathObj.value = from;
      return true;
    });
    onActivated(function () {
      var _beforePath$value, _route$query, _route$query2, _beforePath$value2;
      if (!((_beforePath$value = beforePath.value) !== null && _beforePath$value !== void 0 && _beforePath$value.includes('deviceAlarm'))) {
        store.commit('deviceAlarm/setScrollTop', 0);
      }
      var id = ((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.id) || '';
      var deviceWarnStatus = ((_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.deviceWarnStatus) || '';
      if ((_beforePath$value2 = beforePath.value) !== null && _beforePath$value2 !== void 0 && _beforePath$value2.includes('deviceAlarm/handleAlarm') && deviceWarnStatus && id) {
        var newAlarmList = alarmList.value.map(function (item) {
          var obj = _objectSpread({}, item);
          if (id == item.id) {
            obj.deviceWarnStatus = deviceWarnStatus;
          }
          return obj;
        });
        console.log(newAlarmList);
        alarmList.value = newAlarmList;
      }
      document.documentElement.scrollTop = scrollTop.value;
    });
    onMounted(function () {
      // 监听页面滚动事件
      beforePath.value = '';
      store.commit('deviceAlarm/setScrollTop', 0);
      postWarnRule();
      console.log('初始化');
    });
    onUnmounted(function () {
      window.removeEventListener('scroll', onScrollHandle);
    });
    return function (_ctx, _cache) {
      var _component_van_search = _resolveComponent("van-search");
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_list = _resolveComponent("van-list");
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_picker = _resolveComponent("van-picker");
      var _component_van_popup = _resolveComponent("van-popup");
      var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createBlock(ContentPage, {
        "class-name": "device-alarm-page"
      }, {
        nav: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_search, {
            modelValue: _unref(searchVal),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(searchVal) ? searchVal.value = $event : null;
            }),
            "show-action": "",
            placeholder: "搜索设备名称",
            onSearch: onSearchVal,
            onClear: onClear
          }, {
            action: _withCtx(function () {
              return [_createElementVNode("div", {
                class: "right-filter"
              }, [_createElementVNode("div", {
                onClick: onFilterSearch,
                class: "filter-text"
              }, "筛选"), _createElementVNode("img", {
                onClick: onFilterSearch,
                src: _imports_0
              })])];
            }),
            _: 1
          }, 8, ["modelValue"])])];
        }),
        content: _withCtx(function () {
          return [_createVNode(_component_van_pull_refresh, {
            modelValue: _unref(loading),
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return _isRef(loading) ? loading.value = $event : null;
            }),
            onRefresh: onRefresh
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_list, {
                loading: _unref(listloading),
                "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) {
                  return _isRef(listloading) ? listloading.value = $event : null;
                }),
                finished: _unref(finished),
                "finished-text": "没有更多了",
                onLoad: onLoad,
                "immediate-check": false
              }, {
                default: _withCtx(function () {
                  return [_createVNode(CollapseList, {
                    listData: _unref(alarmList)
                  }, {
                    footer: _withCtx(function (_ref4) {
                      var item = _ref4.item;
                      return [_createElementVNode("div", _hoisted_2, [item.deviceWarnStatus == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 已修复 ")) : _createCommentVNode("", true), item.deviceWarnStatus == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 未修复 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [item.dealWithName || item.deviceWarnStatus == 0 ? (_openBlock(), _createBlock(_component_van_button, {
                        key: 0,
                        onClick: function onClick() {
                          return goToDetail(item.id);
                        },
                        plain: "",
                        type: "primary",
                        class: "footer-user-action result"
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(" 结果 ")];
                        }),
                        _: 2
                      }, 1032, ["onClick"])) : _createCommentVNode("", true), !item.dealWithName && item.deviceWarnStatus == 1 ? (_openBlock(), _createBlock(_component_van_button, {
                        key: 1,
                        type: "primary",
                        class: "footer-user-action",
                        onClick: function onClick() {
                          return goToHandle(item.id);
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(" 处理 ")];
                        }),
                        _: 2
                      }, 1032, ["onClick"])) : _createCommentVNode("", true)])];
                    }),
                    _: 1
                  }, 8, ["listData"])];
                }),
                _: 1
              }, 8, ["loading", "finished"]), _createVNode(_component_van_popup, {
                show: _unref(filterModalShow),
                "onUpdate:show": _cache[7] || (_cache[7] = function ($event) {
                  return _isRef(filterModalShow) ? filterModalShow.value = $event : null;
                }),
                position: "bottom",
                class: "filter-modal-show"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "filter-top"
                  }, [_hoisted_6, _hoisted_7, _createElementVNode("div", {
                    class: "filter-top-cancel",
                    onClick: onFilterCancel
                  }, "取消")]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_van_field, {
                    modelValue: _unref(deviceModel),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _isRef(deviceModel) ? deviceModel.value = $event : null;
                    }),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_van_field, {
                    modelValue: _unref(warnStatus).label,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return _unref(warnStatus).label = $event;
                    }),
                    "is-link": "",
                    readonly: "",
                    placeholder: "请选择",
                    onClick: _cache[4] || (_cache[4] = function ($event) {
                      return _unref(warnStatus).warnStatusPicker = true;
                    })
                  }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
                    show: _unref(warnStatus).warnStatusPicker,
                    "onUpdate:show": _cache[6] || (_cache[6] = function ($event) {
                      return _unref(warnStatus).warnStatusPicker = $event;
                    }),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_van_picker, {
                        columns: _unref(warnStatus).list,
                        onCancel: _cache[5] || (_cache[5] = function ($event) {
                          return _unref(warnStatus).warnStatusPicker = false;
                        }),
                        onConfirm: onStatusConfirm
                      }, null, 8, ["columns"])];
                    }),
                    _: 1
                  }, 8, ["show"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_button, {
                    type: "default",
                    onClick: onRest
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("重置")];
                    }),
                    _: 1
                  }), _createVNode(_component_van_button, {
                    type: "primary",
                    onClick: onFilterOk
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode("确定筛选")];
                    }),
                    _: 1
                  })])];
                }),
                _: 1
              }, 8, ["show"])];
            }),
            _: 1
          }, 8, ["modelValue"])];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_13, [_createVNode(_component_van_button, {
            round: "",
            block: "",
            color: "#4475FD",
            icon: "setting-o",
            onClick: goToAddRule
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("告警规则设置")];
            }),
            _: 1
          })])];
        }),
        _: 1
      });
    };
  }
}));